import {API_BASE_URLS} from 'common/apis'
import {Environment} from 'common/enums'

export const URL_REGEX =
  /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_+.~#?&/=]*)$/

export const USER_NOT_AUTHORIZED_MESSAGE = 'User does not have access'
export const NOTIFICATION_NOT_GRANTED_MESSAGE = `Don't miss out on important updates! Enable browser notifications to stay informed. Please note that some browser modes may prevent notifications from appearing.`

export const TABLE_PAGINATION_PAGE_SIZE = 50

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '')

const resolveApiBaseUrl = (value?: string | null) =>
  trimTrailingSlash(value?.trim() || '')

const LEGACY_LOCAL_PUBLIC_BASE_URL = 'http://localhost:3002'
const PROOF_LOCAL_PUBLIC_BASE_URL = 'http://localhost:3004'
const LEGACY_LOCAL_API_BASE_URL = 'http://127.0.0.1:5100'
const PROOF_LOCAL_API_BASE_URL = 'http://127.0.0.1:5101'

const isLocalHost = (value: string) =>
  value === 'localhost' || value === '127.0.0.1'

const getBrowserLocalPublicBaseUrl = () => {
  if (typeof window === 'undefined') return ''
  if (!isLocalHost(window.location.hostname)) return ''
  return window.location.port === '3001'
    ? PROOF_LOCAL_PUBLIC_BASE_URL
    : LEGACY_LOCAL_PUBLIC_BASE_URL
}

const getBrowserLocalApiBaseUrl = () => {
  if (typeof window === 'undefined') return ''
  if (!isLocalHost(window.location.hostname)) return ''
  return window.location.port === '3001'
    ? PROOF_LOCAL_API_BASE_URL
    : LEGACY_LOCAL_API_BASE_URL
}

const getServerLocalPublicBaseUrl = () => {
  const port = `${process.env.PORT || ''}`.trim()
  if (!port) return ''
  return port === '3001'
    ? PROOF_LOCAL_PUBLIC_BASE_URL
    : port === '3000'
    ? LEGACY_LOCAL_PUBLIC_BASE_URL
    : ''
}

const getServerLocalApiBaseUrl = () => {
  const port = `${process.env.PORT || ''}`.trim()
  if (!port) return ''
  return port === '3001'
    ? PROOF_LOCAL_API_BASE_URL
    : port === '3000'
    ? LEGACY_LOCAL_API_BASE_URL
    : ''
}

const environment =
  (process.env.REACT_APP_PUBLIC_APPLICATION_ENVIRONMENT as Environment) ||
  Environment.DEVELOPMENT

export const BASE_URL = trimTrailingSlash(
  getBrowserLocalPublicBaseUrl() ||
    process.env.REACT_APP_PUBLIC_BASE_URL?.trim() ||
    getServerLocalPublicBaseUrl() ||
    (environment === Environment.DEVELOPMENT
      ? LEGACY_LOCAL_PUBLIC_BASE_URL
      : '')
)

export const API_HOST_URL = resolveApiBaseUrl(
  getBrowserLocalApiBaseUrl() ||
    process.env.REACT_APP_API_URL?.trim() ||
    getServerLocalApiBaseUrl() ||
    (environment === Environment.DEVELOPMENT
      ? LEGACY_LOCAL_API_BASE_URL
      : API_BASE_URLS[environment])
)
